exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".point_lab[data-v-5cb52e25]{font-size:1.7rem;padding-right:.5rem;letter-spacing:.1rem;font-weight:700}", ""]);

// exports
